import React, { useState, useEffect } from 'react';
import { AlertCircle, ChevronRight, X } from 'lucide-react';
import { checkSystemHealth } from '../services/configAuditService';

/**
 * Banner cảnh báo khi hệ thống thiếu cấu hình quan trọng
 */
const SetupAlertBanner = ({ userId }) => {
    const [gaps, setGaps] = useState([]);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (!userId) return;
        
        const fetchHealth = async () => {
            const healthGaps = await checkSystemHealth(userId);
            setGaps(healthGaps);
        };

        fetchHealth();
    }, [userId]);

    if (!isVisible || gaps.length === 0) return null;

    const currentGap = gaps[0]; // Hiển thị lỗi đầu tiên quan trọng nhất

    return (
        <div className="fixed top-20 left-1/2 -translate-x-1/2 z-[100] w-full max-w-2xl px-4 animate-in fade-in slide-in-from-top-4 duration-500">
            <div className="bg-amber-500/10 border border-amber-500/20 backdrop-blur-xl rounded-2xl p-4 shadow-2xl flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-amber-500/20 flex items-center justify-center shrink-0">
                    <AlertCircle className="text-amber-500" size={24} />
                </div>
                
                <div className="flex-1">
                    <h4 className="text-amber-400 text-sm font-black uppercase tracking-widest leading-none mb-1">
                        {currentGap.title}
                    </h4>
                    <p className="text-amber-200/60 text-xs font-bold leading-tight">
                        {currentGap.message}
                    </p>
                </div>

                <div className="flex items-center gap-2">
                    <a 
                        href={currentGap.link}
                        className="px-4 py-2 bg-amber-500 text-black text-[10px] font-black uppercase tracking-widest rounded-lg flex items-center gap-1 hover:bg-amber-400 transition-colors"
                    >
                        {currentGap.action}
                        <ChevronRight size={14} />
                    </a>
                    
                    <button 
                        onClick={() => setIsVisible(false)}
                        className="p-2 text-amber-500/40 hover:text-amber-500 transition-colors"
                    >
                        <X size={18} />
                    </button>
                </div>
            </div>
            
            {gaps.length > 1 && (
                <div className="mt-2 text-center">
                    <p className="text-amber-500/40 text-[9px] font-black uppercase tracking-widest">
                        Còn {gaps.length - 1} bước thiết lập khác cần hoàn tất
                    </p>
                </div>
            )}
        </div>
    );
};

export default SetupAlertBanner;
